import add from "./addProcessingUser";
import edit from "./editProcessingUser";
import remove from "./removeProcessingUser";
import block from "./blockProcessingUser";
import unblock from "./unblockProcessingUser";
import role from "./role";
import access from "./access";

export default {
  add,
  edit,
  remove,
  block,
  unblock,
  role,
  access,
};



// WEBPACK FOOTER //
// ./src/model/gql/mutations/users/processingUser/index.js